<div class="dialog-header flex justify-content-between align-items-center w-full">
  <h2>Confirmare</h2>
  <p-button
    size="small"
    mat-dialog-close
    icon="pi pi-times"
    severity="secondary"
    [rounded]="true"
    [text]="true"
  />
</div>
<mat-dialog-content>
  <p class="font-bold">Sunteți sigur că doriți să ștergeți acest utilizator?</p>
  <div class="flex flex-column">
    <p class="m-0"><b>Email</b>: {{ platformUser.email }}</p>
    <p class="m-0"><b>Nume</b>: {{ platformUser.name }}</p>
    <p class="m-0"><b>Rol</b>: {{ platformUser.role }}</p>
    <p class="m-0"><b>Telefon</b>: {{ platformUser.phone }}</p>
  </div>
  <p class="text-red-500">Atentie! Stergerea utilizatorului va deconecta toate dispozitivele conectate la acest cont!</p>
  <div class="flex align-items-center gap-2 mt-4 mb-2">
    <p-checkbox
      inputId="confirm-delete"
      [binary]="true"
      (onChange)="confirmed.set($event.checked)"
    ></p-checkbox>
    <label for="confirm-delete">Confirm ștergerea utilizatorului</label>
  </div>
</mat-dialog-content>
<mat-dialog-actions class="flex gap-2">
  <p-button
    size="small"
    mat-dialog-close
    data-testid="dialog-secondary"
    label="Anulează"
    [text]="true"
  ></p-button>
  <p-button
    size="small"
    severity="danger"
    data-testid="dialog-primary"
    label="Șterge"
    icon="pi pi-trash"
    [disabled]="!confirmed()"
    (onClick)="deletePlatformUser()"
  ></p-button>
</mat-dialog-actions>
@if (deleting()) {
  <div class="blurred-div">
    <p-progressSpinner class="blurred-div-spinner"></p-progressSpinner>
  </div>
}